import React, { createContext, useContext, useState } from 'react';

const AIWidgetContext = createContext();

export const AIWidgetProvider = ({ children }) => {
  const [isAssistantOpen, setIsAssistantOpen] = useState(false);

  const openAssistant = () => setIsAssistantOpen(true);
  const closeAssistant = () => setIsAssistantOpen(true); // Wait, should be false!

  const toggleAssistant = () => setIsAssistantOpen((prev) => !prev);

  return (
    <AIWidgetContext.Provider 
      value={{ 
        isAssistantOpen, 
        setIsAssistantOpen, 
        openAssistant, 
        closeAssistant: () => setIsAssistantOpen(false),
        toggleAssistant 
      }}
    >
      {children}
    </AIWidgetContext.Provider>
  );
};

export const useAIWidget = () => {
  const context = useContext(AIWidgetContext);
  if (!context) {
    throw new Error('useAIWidget must be used within an AIWidgetProvider');
  }
  return context;
};

export default AIWidgetContext;
